import './styles/BubbleBurst.css';

export default function BubbleBurst({ active = false, className = '', children }) {
  return (
    <span className={`bubble-burst__wrapper ${className} ${active ? 'burst' : ''}`}>
      {children}

      <span className="bubble-burst__bubble bubble-0" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-1" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-2" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-3" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-4" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-5" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-6" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-7" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-8" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-9" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-10" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-11" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-12" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-13" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-14" aria-hidden="true"></span>
      <span className="bubble-burst__bubble bubble-15" aria-hidden="true"></span>
    </span>
  );
}
